module.exports = __webpack_public_path__ + "assets/38910c776df869b700a870254eff3f30.png";